import angular from "angular"
import facilityOptions from "./facility-options"
export default class DialogController {
  /*@ngInject*/
  constructor(
    $scope,
    $mdDialog,
    data,
    $http,
    $window,
    isEditing,
    $q,
    changePosition,
    pitchImageUrls,
    updatePitchMarkers,
    deleteMarker,
    updateMap,
    isAdmin,
    editMarkerInteractionShape
  ) {
    this.$http = $http
    this.data = data
    this.isEditing = isEditing
    this.$scope = $scope
    this.$mdDialog = $mdDialog
    this.$scope.showNewPitchForm = false
    this.$window = $window

    this.changePosition = changePosition
    this.pitchImageUrls = pitchImageUrls
    this.updatePitchMarkers = updatePitchMarkers
    this.deleteMarker = deleteMarker
    this.updateMap = updateMap
    this.isAdmin = isAdmin
    this.editMarkerInteractionShape = editMarkerInteractionShape
  }

  resetMarkerDefaults() {
    this.$scope.showNewPitchForm = false
    this.$scope.showNewFacilityForm = false
    this.$scope.showNewAreaForm = false
  }

  updateExistingArea() {
    this.areaOptions[this.editingIndex] = {
      areaBookingId: this.newAreaOption.areaBookingId,
      centerlat: this.currentMapPointPosition.lat,
      centerlng: this.currentMapPointPosition.lng,
      desc: this.newAreaOption.numRange,
      isAreaPitchesMerged: this.newAreaOption.isAreaPitchesMerged,
      name: this.newAreaOption.newAreaName,
    }
    this.updateMap("areaoptions", this.areaOptions)
  }

  setCurrentFacilityFeatureStatus() {
    var selected = []
    angular.forEach(this.newFacility.facilityfeatures, (s, index) => {
      const optionExists = this.facilityOptions.find((option) => option.name === s)
      if (!optionExists) {
        this.newFacility.facilityfeatures.splice(index)
      } else {
        selected.push(s)
      }
    })
    this.currentFacilityFeatureStatus = selected.length ? selected.join(", ") : "Not set"
  }

  isAreaNameAlreadyUsed(name) {
    if (this.isEditing) {
      if (name === this.initialAreaName) {
        return false
      }
    }
    this.data.campsiteInfo.areaoptions.find((markerLayer) => markerLayer.name === name)
  }

  checkIfDuplicate(markerGroupName, urlstringid) {
    let count = 0
    this.data.campsiteInfo[markerGroupName].forEach((item) => {
      if (item.urlstringid === urlstringid) {
        count++
      }
    })

    if (this.isEditing) {
      if (count > 1) {
        return true
      } else if (count === 1 && urlstringid !== this.data.markerData.urlstringid) {
        return true
      } else {
        return false
      }
    }

    if (count) {
      return true
    }
  }

  newMarkerNameNotDuplicate(markerGroupName, marker) {
    let urlstringid

    if (markerGroupName === "markers" && this.data.campsiteInfo.pitchnumberbyarea && marker.area) {
      urlstringid = `${marker.name}-${marker.area.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()}`
    } else {
      urlstringid = marker.name.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
    }

    const isDuplicate = this.checkIfDuplicate(markerGroupName, urlstringid)
    if (isDuplicate) {
      this.dialogError = "There is a duplicate name, please rename or delete existing marker"
      return false
    } else {
      this.resetDialogError()
      return true
    }
  }

  checkSaveState() {
    console.log("checkSaveState")
    this.markerSaveEnabled = false

    if (this.newMarkerOptionType.name === "facility") {
      if (
        this.newFacility.name &&
        this.newFacility.name !== "" &&
        this.newMarkerNameNotDuplicate("facilities", this.newFacility) &&
        this.newFacility.desc &&
        this.newFacility.desc !== "" &&
        this.newFacility.facilitytype
      ) {
        this.markerSaveEnabled = true
      }
    }

    if (this.newMarkerOptionType.name === "area") {
      if (
        this.newArea.name &&
        this.newArea.name !== "" &&
        this.newMarkerNameNotDuplicate("areaoptions", this.newArea) &&
        !this.isAreaNameAlreadyUsed(this.newArea.name)
      ) {
        this.markerSaveEnabled = true
      }
    }

    if (this.newMarkerOptionType.name === "poi") {
      if (this.newPoi.name && this.newMarkerNameNotDuplicate("placesofinterest", this.newPoi) && this.newPoi.desc) {
        this.markerSaveEnabled = true
      }
    }

    if (this.newMarkerOptionType.name === "plot") {
      this.markerSaveEnabled = true // this is temporary will need more prep in future
      // this.pitchTypeSubTypes = this.setPitchTypeSubTypes()
      // if (this.newPitch.name && this.newPitch.name !== "" && this.newMarkerNameNotDuplicate("markers", this.newPitch)) {
      //   if (this.data.campsiteInfo.pitchNumbersOnPitchTypes) {
      //     this.markerSaveEnabled = true
      //   } else if (this.newPitch.pitchtype) {
      //     this.markerSaveEnabled = true
      //   }
      //   if (this.data.campsiteInfo.pitchnumberbyarea) {
      //     if (this.newPitch.area) {
      //       this.markerSaveEnabled = true
      //     }
      //   }
      // }
    }
  }

  getFacilityByUrlStringId(urlstringid) {
    return this.data.campsiteInfo.facilities.find((markerLayer) => markerLayer.urlstringid === urlstringid)
  }

  getAreaByUrlStringId(urlstringid) {
    return this.data.campsiteInfo.areaoptions.find((markerLayer) => markerLayer.name === urlstringid)
  }

  getPitchId(urlstringid) {
    return this.data.campsiteInfo.markers.find((markerLayer) => markerLayer.urlstringid === urlstringid)._id
  }

  getMarkerIndex(urlstringid, type) {
    return this.data.campsiteInfo[type].findIndex((markerLayer) => markerLayer.urlstringid === urlstringid)
  }

  sortByPhysicalUnitName(str1, str2) {
    return parseInt(str1.name, 10) - parseInt(str2.name, 10)
  }

  checkPhysicalUnitData() {
    if (this.isEditing) {
      if (this.newPitch.isMultiPhysicalUnits) {
        this.newPitch.physicalUnitIds = this.newPitch.physicalUnitIds
          ? this.convertNumbersArrayToString(this.newPitch.physicalUnitIds)
          : ""
      } else if (this.newPitch.physicalunitids && this.newPitch.physicalunitids.length) {
        this.physicalUnitIdForSave = this.newPitch.physicalunitids[0]
      }
    }
  }

  convertStringToNumberArray(physicalUnitIdsString) {
    return physicalUnitIdsString.split(" ").map((item) => parseInt(item, 10))
  }

  convertNumbersArrayToString(numbersArray) {
    return numbersArray.map(String).join()
  }

  editPitch() {
    this.newPitch = {
      ...this.data.markerData,
    }
    this.showNewPitchForm = true

    if (this.data.campsiteInfo.booksystemname === "GemaPark" || this.data.campsiteInfo.booksystemname === "Anytime") {
      this.checkPhysicalUnitData()
    }
  }

  getUrlStringIdFromName(name) {
    return name.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
  }

  handleFacDesSave = (val) => {
    this.newFacility.desc = val
    this.checkSaveState()
  }

  handlePoiDesSave = (val) => {
    this.newPoi.desc = val
    this.checkSaveState()
  }

  saveFacilityToServer() {
    const facilitiesArray = [...this.data.campsiteInfo.facilities]
    this.newFacility.lat = this.data.markerLatLng.lat
    this.newFacility.lng = this.data.markerLatLng.lng
    this.newFacility.urlstringid = this.getUrlStringIdFromName(this.newFacility.name)
    if (this.isEditing) {
      const facilityIndex = this.getMarkerIndex(this.newFacility.urlstringid, "facilities")
      facilitiesArray[facilityIndex] = this.newFacility
    } else {
      facilitiesArray.push(this.newFacility)
    }

    this.updateMap("facilities", facilitiesArray)
  }

  savePoiToServer() {
    const poisArray = [...this.data.campsiteInfo.placesofinterest]
    this.newPoi.lat = this.data.markerLatLng.lat
    this.newPoi.lng = this.data.markerLatLng.lng
    this.newPoi.urlstringid = this.getUrlStringIdFromName(this.newPoi.name)
    if (this.isEditing) {
      const poiIndex = this.getMarkerIndex(this.newPoi.urlstringid, "placesofinterest")
      poisArray[poiIndex] = this.newPoi
    } else {
      poisArray.push(this.newPoi)
    }

    this.updateMap("placesofinterest", poisArray)
  }

  saveAreaToServer() {
    const areaArray = [...this.data.campsiteInfo.areaoptions]
    this.newArea.centerlat = this.data.markerLatLng.lat
    this.newArea.centerlng = this.data.markerLatLng.lng
    if (this.isEditing) {
      const areaIndex = this.getMarkerIndex(this.newArea.urlstringid, "areaoptions")
      areaArray[areaIndex] = this.newArea
    } else {
      areaArray.push(this.newArea)
    }

    this.updateMap("areaoptions", areaArray)
  }

  editArea() {
    const area = this.getAreaByUrlStringId(this.data.markerData.name)
    this.newArea = { ...area }
    this.showNewAreaForm = true
  }

  stringToNumber(numStr) {
    return parseInt(numStr, 10)
  }

  editFacility() {
    const facility = this.getFacilityByUrlStringId(this.data.markerData.urlstringid)
    this.facilityOptions = facilityOptions
    this.newFacility = { ...facility }
    if (!this.newFacility.numOfPhotos) {
      this.newFacility.numOfPhotos = 1
    }
    this.showNewFacilityForm = true
  }

  getNewPitchToSave() {
    const data = this.data
    const { lat, lng } = data.markerLatLng
    const { name } = data.campsiteInfo
    const version = data.campsiteInfo.version || ""
    return {
      lat,
      lng,
      campsite: `${name}${version}`,
      ...this.newPitch,
    }
  }

  savePitchToServer() {
    let newPitchToSave = this.getNewPitchToSave()
    if (this.physicalUnitIdForSave) {
      if (this.newPitch.isMultiPhysicalUnits) {
        newPitchToSave.physicalunitids = this.convertStringToNumberArray(this.newPitch.physicalunitids)
      } else {
        const physicalUnitId = this.physicalUnitIdForSave
        newPitchToSave.physicalunitids = [physicalUnitId]
      }

      this.physicalUnitIdForSave = null
    }

    this.updatePitchMarkers(newPitchToSave, this.isEditing)
  }

  editMarker() {
    this.showInitMarkerControls = false
    if (this.data.markerData.type === "pitch") {
      this.editPitch()
      this.newMarkerOptionType.name = "plot"
      this.pitchTypeSubTypes = this.setPitchTypeSubTypes()
    } else if (this.data.markerData.type === "facility") {
      this.editFacility()
      this.newMarkerOptionType.name = "facility"
    } else if (this.data.markerData.type === "area") {
      this.editArea()
      this.initialAreaName = this.data.markerData.name
      this.newMarkerOptionType.name = "area"
    }

    this.checkSaveState()
  }

  resetDialogError() {
    this.dialogError = ""
  }

  changeNewMarkerType() {
    this.resetMarkerDefaults()
    if (this.newMarkerOptionType.name === "plot") {
      this.showNewPitchForm = true
      this.newPitch = {}
      if (this.data.campsiteInfo.booksystemname === "GemaPark") {
        this.checkPhysicalUnitData()
      }
    }

    if (this.newMarkerOptionType.name === "facility") {
      this.facilityOptions = facilityOptions
      this.newFacility = {}
      this.showNewFacilityForm = true
    }

    if (this.newMarkerOptionType.name === "poi") {
      this.newPoi = {}
      this.showNewPoiForm = true
    }

    if (this.newMarkerOptionType.name === "area") {
      this.newArea = {}
      this.showNewAreaForm = true
    }
  }

  save() {
    if (this.newMarkerOptionType.name === "plot") {
      console.log("save plot")
      this.savePitchToServer()
    }

    if (this.newMarkerOptionType.name === "facility") {
      console.log("save facility")
      this.saveFacilityToServer()
    }

    if (this.newMarkerOptionType.name === "poi") {
      console.log("save poi")
      this.savePoiToServer()
    }

    if (this.newMarkerOptionType.name === "area") {
      console.log("save area")
      this.saveAreaToServer()
    }
  }

  hide() {
    this.$mdDialog.hide()
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  setAreaOptionArray() {
    this.areaOptionArray = [...this.data.campsiteInfo.areaoptions, { name: "" }]
  }

  setPitchTypeSubTypes() {
    const currentPitchType = this.data.campsiteInfo.pitchtypes.find(
      (pitchType) => pitchType.type === this.newPitch.pitchtype
    )

    if (currentPitchType && currentPitchType.subTypes && currentPitchType.subTypes.length) {
      return currentPitchType.subTypes
    }
  }

  $onInit() {
    this.dialogError = ""
    this.newMarkerOptionType = {}
    this.setAreaOptionArray()
    if (this.isEditing) {
      this.showInitMarkerControls = true
    } else {
      this.markerOptionTypes = [{ name: "plot" }, { name: "facility" }, { name: "area" }, { name: "poi" }]
    }
  }
}
